import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useToast } from '../../contexts/ToastContext';
import styles from './loginparticipantepage.module.css';
import { useParticipanteService } from '../../services/participanteServices';

function RecuperarSenhaCodigoPage() {
    const { showToast } = useToast();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { t } = useTranslation();

    const { atualizarSenhaParticipante, obterParticipantePorId } = useParticipanteService();

    const idParticipante = searchParams.get('id');

    const [participante, setParticipante] = useState(null);
    const [codigo, setCodigo] = useState('');
    const [novaSenha, setNovaSenha] = useState('');
    const [confirmarSenha, setConfirmarSenha] = useState('');
    const [carregando, setCarregando] = useState(false);
    const [erro, setErro] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErro('');

        if (novaSenha !== confirmarSenha) {
            setErro(t('auth.passwordsMismatch'));
            return;
        }

        setCarregando(true);

        try {
            const result = await atualizarSenhaParticipante({
                idParticipante: idParticipante,
                codigo: codigo.trim(),
                novaSenha: novaSenha.trim(),
            });

            if (result.success) {
                showToast(t('auth.passwordChanged'), 3000, 'success');
                navigate('/participante/login');
            } else {
                setErro(result.message || t('auth.resetFailed'));
                showToast(result.message || t('auth.resetFailed'), 3000, 'error');
            }
        } catch (error) {
            console.error(error);
            setErro(t('auth.resetError'));
            showToast(t('auth.resetError'), 3000, 'error');
        }

        setCarregando(false);
    };

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>{t('auth.resetTitle')}</h2>

            <form onSubmit={handleSubmit} className={styles.form}>
                <input
                    type="text"
                    placeholder={t('auth.sixDigitCode')}
                    value={codigo}
                    onChange={(e) => setCodigo(e.target.value)}
                    className={styles.input}
                    required
                />

                <input
                    type="password"
                    placeholder={t('auth.newPassword')}
                    value={novaSenha}
                    onChange={(e) => setNovaSenha(e.target.value)}
                    className={styles.input}
                    required
                />

                <input
                    type="password"
                    placeholder={t('auth.confirmNewPassword')}
                    value={confirmarSenha}
                    onChange={(e) => setConfirmarSenha(e.target.value)}
                    className={styles.input}
                    required
                />

                <button type="submit" className={styles.button} disabled={carregando}>
                    {carregando ? t('common.saving') : t('auth.savePassword')}
                </button>

                {erro && <p className={styles.error}>{erro}</p>}
            </form>
        </div>
    );
}

export default RecuperarSenhaCodigoPage;
